// src/pages/policy/sections/RefundPolicy.jsx
import { motion } from "framer-motion";
const item = {
  hidden: { opacity: 0, y: 6 },
  show: { opacity: 1, y: 0, transition: { duration: 0.16 } },
};

export default function RefundPolicy() {
  return (
    <section className="mb-12 space-y-4 text-gray-700 text-[15px] leading-relaxed">
      <motion.h2
        className="text-2xl font-bold text-gray-800 mb-2"
        variants={item}
        initial="hidden"
        animate="show"
      >
        Chính sách hoàn tiền & hỗ trợ người dùng
      </motion.h2>

      <motion.p variants={item} initial="hidden" animate="show">
        Chính sách hoàn tiền được thiết lập để bảo vệ quyền lợi người dùng khi
        phát sinh lỗi hệ thống...
      </motion.p>

      <motion.ul
        className="list-disc list-inside ml-5 space-y-1"
        variants={item}
        initial="hidden"
        animate="show"
      >
        <li>Thanh toán nhầm gói dịch vụ và chưa sử dụng tài nguyên.</li>
        <li>Lỗi hệ thống dẫn đến không thể truy cập dịch vụ đã thanh toán.</li>
      </motion.ul>

      <motion.p variants={item} initial="hidden" animate="show">
        Gửi yêu cầu đến <strong>dangky@sohuutritue.vn</strong> kèm thông tin
        giao dịch...
      </motion.p>
    </section>
  );
}
